import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tags", "checkbox", "dropdown", "results"]
  static values = { url: String }

  connect() {
    this.isOpen = false
    this.updateTags()
    this.handleWheel = this.handleWheel.bind(this)
    this.tagsTarget.addEventListener("wheel", this.handleWheel, { passive: false })
  }

  disconnect() {
    this.tagsTarget.removeEventListener("wheel", this.handleWheel)
  }

  handleWheel(e) {
    if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return
    if (e.deltaY === 0) return

    const container = this.tagsTarget
    const maxScrollLeft = container.scrollWidth - container.clientWidth

    if (maxScrollLeft <= 0) return

    const atStart = container.scrollLeft <= 0
    const atEnd = container.scrollLeft >= maxScrollLeft - 1

    if ((e.deltaY < 0 && atStart) || (e.deltaY > 0 && atEnd)) return

    e.preventDefault()
    container.scrollLeft += e.deltaY
  }

  clickOutsideHandler(e) {
    if (!this.element.contains(e.target)) {
      this.dropdownTarget.classList.remove("active")
      this.isOpen = false
    }
  }

  toggleDropdown() {
    this.dropdownTarget.classList.toggle("active", !this.isOpen)
    this.isOpen = !this.isOpen
  }

  toggle() {
    this.updateTags()
    this.updateProjects()
  }

  remove(e) {
    const value = e.currentTarget.dataset.value
    const checkbox = this.checkboxTargets.find(cb => cb.value === value)
    if (checkbox) {
      checkbox.checked = false
      this.updateTags()
      this.updateProjects()
    }
  }

  updateTags() {
    const selected = this.checkboxTargets.filter(cb => cb.checked)
    this.tagsTarget.innerHTML = selected.map(cb => this.buildTag(cb.value, cb.dataset.label)).join("")
  }

  buildTag(value, label) {
    return `
      <button type="button" class="inline-flex items-center gap-2 px-4 py-2.5 bg-neutral-0 rounded-[20px] text-grey-600 cursor-default whitespace-nowrap" data-action="click->sector-filter#remove" data-value="${value}">
        <span>${label}</span>
        <i class="far fa-times text-grey-400 hover:text-grey-600 cursor-pointer"></i>
      </button>
    `
  }

  updateProjects() {
    const selectedIds = this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)

    const params = new URLSearchParams()
    selectedIds.forEach(id => params.append("by_content_page_ids[]", id))

    const url = this.urlValue
    const fullUrl = selectedIds.length > 0 ? `${url}?${params.toString()}` : url

    window.history.replaceState({}, "", fullUrl)

    fetch(fullUrl, {
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest" // pour request.xhr? côté Rails
      }
    })
      .then(response => {
        if (!response.ok) throw new Error("Network response was not ok")
        return response.text()
      })
      .then(html => {
        console.log(this.resultsTarget)
        this.resultsTarget.innerHTML = html
      })
      .catch(error => {
        console.error("Erreur lors du chargement des projets :", error)
      })
  }
}
